module.exports = __webpack_public_path__ + "img/55.a9567726.png";